var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-body" },
    _vm._l(_vm.form.rows, function(row, rowIndex) {
      return _c(
        "div",
        { key: rowIndex },
        [
          row.type === "header"
            ? _c("form-header", { attrs: { title: row.content.title } })
            : _vm._e(),
          _vm._v(" "),
          row.type === "row"
            ? _c("span", [
                _c(
                  "div",
                  { staticClass: "row" },
                  _vm._l(row.cols, function(col, colIndex) {
                    return _c(
                      "div",
                      { key: colIndex, staticClass: "col-md-6" },
                      [
                        col.type === "text"
                          ? _c("text-input", {
                              attrs: {
                                name: col.content.name,
                                errors: _vm.form.options.errors,
                                title: col.content.title
                              },
                              model: {
                                value: _vm.form.entity[col.content.name],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.entity,
                                    col.content.name,
                                    $$v
                                  )
                                },
                                expression: "form.entity[col.content.name]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        col.type === "checkbox"
                          ? _c("checkbox", {
                              attrs: {
                                name: col.content.name,
                                checked: _vm.form.entity[col.content.name],
                                errors: _vm.form.options.errors,
                                label: col.content.title
                              },
                              model: {
                                value: _vm.form.entity[col.content.name],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.entity,
                                    col.content.name,
                                    $$v
                                  )
                                },
                                expression: "form.entity[col.content.name]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        col.type === "multiselect"
                          ? _c("multiselect", {
                              attrs: {
                                name: col.content.name,
                                errors: _vm.form.options.errors,
                                checked: _vm.form.entity[col.content.selected],
                                options: _vm.form.options[col.content.name],
                                title: col.content.title,
                                "track-by": col.content.trackBy
                                  ? col.content.trackBy
                                  : "id",
                                label: col.content.label
                                  ? col.content.label
                                  : "name"
                              },
                              model: {
                                value: _vm.form.entity[col.content.name],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.entity,
                                    col.content.name,
                                    $$v
                                  )
                                },
                                expression: "form.entity[col.content.name]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        col.type === "singleselect"
                          ? _c("singleselect", {
                              attrs: {
                                name: col.content.name,
                                errors: _vm.form.options.errors,
                                options: _vm.form.options[col.content.name],
                                title: col.content.title
                              },
                              model: {
                                value: _vm.form.entity[col.content.name],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.entity,
                                    col.content.name,
                                    $$v
                                  )
                                },
                                expression: "form.entity[col.content.name]"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        col.type === "tel"
                          ? _c("text-input", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "+(##) ###-###-###",
                                  expression: "'+(##) ###-###-###'"
                                }
                              ],
                              attrs: {
                                name: col.content.name,
                                errors: _vm.form.options.errors,
                                title: col.content.title,
                                type: "tel"
                              },
                              model: {
                                value: _vm.form.entity[col.content.name],
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.form.entity,
                                    col.content.name,
                                    $$v
                                  )
                                },
                                expression: "form.entity[col.content.name]"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6637b0fa", { render: render, staticRenderFns: staticRenderFns })
  }
}